import { render } from "./AccordionComponent.vue?vue&type=template&id=3baba4a9"
import script from "./AccordionComponent.vue?vue&type=script&lang=js"
export * from "./AccordionComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__